import {
  MapUtil,
  DomUtil
} from "cartovista";
import BtnInfoPanToolExtend from "./BtnInfoPanToolExtend";
import "../../css/ClustersZoom.css";

export default class ClustersZoom {
    constructor() {
        window.cartovista.addOneTimeEventListener(window.cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
        window.cartovista.addEventListener("Extend_onBtnInfoPanToolMouseUp", this._onBtnInfoPanToolMouseUp, this);
        window.cartovista.addEventListener("Extend_onBtnInfoPanToolMouseMove", this._onBtnInfoPanToolMouseMove, this);
    };

    _onCartoVistaMapLoaded(evt) {
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);
        this._$divMap = $(this._mapController.divMap);
    };

    _onBtnInfoPanToolMouseUp(evt) {
        var featuresAtPoint = this._getFeaturesAtPoint(evt.source.mouseUpEvent);
        if (featuresAtPoint.length) {
            this._zoomOnFeatures(featuresAtPoint);
        }
    };

    _onBtnInfoPanToolMouseMove(evt) {
        if (this._getFeaturesAtPoint(evt.source.mouseMoveEvent).length) {
            this._$divMap.addClass("ClustersZoom_mouseOverCluster");
        } else {
            this._$divMap.removeClass("ClustersZoom_mouseOverCluster");
        }
    };

    _getFeaturesAtPoint(e) {
        var MouseCoordinates = this.getNormalizedMouseCoordinates(e),
            x = Math.round(MapUtil.screenXtoMapX(MouseCoordinates.x, this._mapController._map.width, this._mapController._map.extent)),
            y = Math.round(MapUtil.screenYtoMapY(MouseCoordinates.y, this._mapController._map.height, this._mapController._map.extent));
        return _.reduce(_.filter(this._map.layers, "clusteringEnabled"), function(features, layer) {
            //zoom only if layer.visible and layer.clusteringActivated
            if (layer.visible && layer.isClusteringActivated) {
                var radius = MapUtil.getSearchAtPointRadius(layer, this._map);
                layer.getFeaturesByPoint(x, y, radius, null, function(result) {
                    _.forEach(result.features, function(feature) {
                        //zoom only on features not filteredOut, visible and in cluster
                        if (!feature.filteredOut && feature.visible && feature.featureCount > 1) {
                            features.push(feature);
                        }
                    });
                });
            }
            return features;
        }.bind(this), []);
    };

    _zoomOnFeatures(features) {
        var zoomOnFeatures = [];
        _.forEach(features, function(feature) {
            if (typeof feature.features != "undefined") {
                zoomOnFeatures = _.concat(zoomOnFeatures, feature.features, [feature.centerFeature]);
            }/* else {
                //in comment to prevent zoom on feature(s) when clustering not activated
                zoomOnFeatures.push(feature);
            }*/
        });
        if (zoomOnFeatures.length) {
            var minX = Math.min.apply(Math, zoomOnFeatures.map(function(f){return f.currentGeometry.extent.minX;})),
                maxX = Math.max.apply(Math, zoomOnFeatures.map(function(f){return f.currentGeometry.extent.maxX;})),
                minY = Math.min.apply(Math, zoomOnFeatures.map(function(f){return f.currentGeometry.extent.minY;})),
                maxY = Math.max.apply(Math, zoomOnFeatures.map(function(f){return f.currentGeometry.extent.maxY;}));
            if (maxX-minX == 0 && maxY-minY == 0) {
                //superposed features
                this._mapController.zoomOnFeatures(zoomOnFeatures, null, 500);
            } else {
                //spreaded features
                this._mapController.zoomOnFeatures(zoomOnFeatures, null, null);
            }
        }
    };

    getNormalizedMouseCoordinates(e) {
        var objectPosition = DomUtil.getAbsolutePosition(this._mapController.divMap);
        var x = e.pageX;
        var y = e.pageY;
        if (e.touches && e.touches.length > 0) {
            x = e.touches[0].pageX;
            y = e.touches[0].pageY;
        } else if (e.changedTouches && e.changedTouches.length > 0) {
            x = e.changedTouches[0].pageX;
            y = e.changedTouches[0].pageY;
        }
        return {
            x: x - objectPosition.left,
            y: y - objectPosition.top
        };
    };
};
